import main from './main.module.scss';
import { LimitFunc } from 'hooks/limit';
import CustomTable from 'components/table';
import { collepseColumns } from './column';
import { buttonGroup7 } from 'configs/data';
import { BiUserCircle } from 'react-icons/bi';
import convertToReadable from 'services/helpers';
import { Box, Collapse, Typography } from '@mui/material';
import { AiOutlineFolder, AiOutlineMan, AiOutlineWoman } from 'react-icons/ai';

type Component = {
  open: boolean;
  data: any;
};

const CustomCollapse = ({ open, data = {} }: Component) => {
  return (
    <Collapse in={open}>
      <Box className={main.collapse}>
        <Box className={main.collapse_left}>
          <Box className={main.head}>
            {data?.policy?.gender === 'Мужской' ? (
              <AiOutlineMan className={main.head_icon} />
            ) : (
              <AiOutlineWoman className={main.head_icon} />
            )}
            <Typography variant='h6' className={main.head_title}>
              {(data?.policy?.last_name || '') +
                ' ' +
                (data?.policy?.first_name || '') +
                ' ' +
                (data?.policy?.patronymic || '')}
            </Typography>
          </Box>

          <Box className={main.body}>
            <Box className={main.wrapper}>
              <Typography variant='h6' className={main.leftText}>
                Номер телефона:
              </Typography>
              <Typography variant='subtitle1' className={main.rightText}>
                {data?.policy?.phone || ''}
              </Typography>
            </Box>
            <Box className={main.wrapper}>
              <Typography variant='h6' className={main.leftText}>
                Программа покрытия:
              </Typography>
              <Typography variant='subtitle1' className={main.rightText}>
                {data?.policy?.insurance_program.name || ''}
              </Typography>
            </Box>
            <Box className={main.wrapper}>
              <Typography variant='h6' className={main.leftText}>
                Тип полюса:
              </Typography>
              <Box className={main.list}>
                <BiUserCircle className={main.userIcon} />
                <Typography variant='subtitle1' className={main.rightText}>
                  {data?.policy?.type.toUpperCase() || ''}
                </Typography>
              </Box>
            </Box>
            <Box className={main.wrapper}>
              <Typography variant='h6' className={main.leftText}>
                Форма рассчета:
              </Typography>

              <Typography variant='subtitle1' className={main.rightText}>
                {buttonGroup7.map((i: any) => i.value === data?.policy?.formula && i.title)}
              </Typography>
            </Box>
          </Box>

          <Box className={main.footer}>
            <Box className={main.container}>
              <AiOutlineFolder className={main.icon} />

              <Box className={main.body}>
                <span className={main.title}>Cтраховая сумма</span>
                <span className={main.subTitle}>
                  {convertToReadable(data?.policy?.insurance_program?.insurance_amount)} uzs
                </span>
              </Box>
            </Box>

            <Box className={main.container}>
              <Box className={main.body}>
                <span className={main.title}>Текущий остаток</span>
                <span className={main.subTitle}>
                  {convertToReadable(data?.policy?.current_balance)} uzs
                </span>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box width='100%' overflow='hidden'>
          <CustomTable
            data={LimitFunc(data?.policy) || []}
            disableFooter={true}
            columns={collepseColumns}
            styles={{
              bg: '#fff',
              headBg: '#F3F8FC',
              borderColor: '#DAEDFF',
              mt: '0',
              minWidth: '100%',
              rowBg: '#F5F5F5',
            }}
          />
        </Box>
      </Box>
    </Collapse>
  );
};

export default CustomCollapse;
